import req from '../../api/request'

/**
 * A schedule the team plays in, as `/teams/:id/schedules/V2` returns it: each
 * carries its own `parent` chain up to the root competition.
 */
export interface TeamScheduleV2 {
  id: string
  type?: string
  parent?: TeamScheduleV2 | null
  [field: string]: unknown
}

/** GET /teams/:teamId/schedules/V2 — the schedules behind a team's filters. */
export const getTeamSchedulesV2 = async (
  teamId: string
): Promise<TeamScheduleV2[]> => {
  const { data } = await req(`/teams/${teamId}/schedules/V2`)
  return (data ?? []) as TeamScheduleV2[]
}
